

import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components"
import { getActiveInput, updateSeferMaliyetData } from "../../features/calc/calcSlice";
import formatConverter from "../../helper/formatConverter";
import { PiEqualsBold } from "react-icons/pi";
import { FaEquals } from "react-icons/fa6";
const Container = styled.div`
      max-width: 100%;
      width: 100%;
      overflow-x: auto;

      .table{
        width: 100%;

        tr{
        width: 100%;

            width: max-content;
        }


        .table-top{

        }
      }
`

const TableTopTitleItem = styled.th`
  background-color: var(--color-main);
  padding: 12px 10px;
  text-align: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-lg);
  color: #fff;
  border: 1px solid var(--color-main);
`;


const TableDataItem = styled.td`
    border: 1px solid ${({theme}) => theme.mainTextColor};
    background-color: ${({theme}) => theme.mainBgColor};
    font-size:  var(--font-size-sm);
    font-weight: var(--font-weight-lg);
    padding: ${({isTitle, isNumber}) => (isTitle || isNumber) ? "12px 10px" : "12px 20px"};
    text-align: ${({isTitle}) => isTitle ? "start" : "center"};
    width: ${({isNumber, isTitle}) => isNumber ? "38px" : isTitle ? "357px" : "auto"};

    .equal-icon{
        fill: ${({theme}) => theme.mainTextColor};
    }

    input{
        width: 100%;
        height: 100%;
        text-align: center;
        font-variant-numeric: lining-nums;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: transparent;
    }
`

const topPropName = ["", "Maliyet Kriterleri", "Tır", "Kırkayak", "10 Teker", "6 Teker", "Kamyonet", "Panelvan", "Kamyon Römork"]

const CostCalculateResponse1 = () => {

    const {costCalculateDataList} = useSelector(state => state.calc)

  return (
    <Container>
            <table className="table">
            <thead className="thead">
                <tr>
                    {
                        topPropName.map((item, i) => (
                            <TableTopTitleItem key={i}>{item}</TableTopTitleItem>
                        ))
                    }
                </tr>
            </thead>
                <tbody className="tbody">
    
                    {/* //! Gerçek Nakliye Maliyeti */}
                    <tr>
                            <TableDataItem isNumber={true}><PiEqualsBold className="equal-icon"/></TableDataItem>
                            <TableDataItem isTitle={true}>Gerçek Nakliye Maliyeti</TableDataItem>
                        {
                            costCalculateDataList.map((item,i) => {
                                return {
                                    gercekNakliyeMaliyeti: item?.gercekNakliyeMaliyeti,
                                }
                            }).map((item, i) => (
                                <TableDataItem key={i}>{formatConverter(item?.gercekNakliyeMaliyeti)}</TableDataItem>
                            ))
                        }
                    </tr>
    
    
                    {/* //! TL/Km */}
                    <tr>
                        <TableDataItem isNumber={true}><PiEqualsBold className="equal-icon"/></TableDataItem>
                        <TableDataItem isTitle={true}>TL/Km</TableDataItem>
                        {
                            costCalculateDataList.map((item,i) => {
                                return {
                                    tlKm: item?.tlKm,
                                }
                            }).map((item, i) => (
                                <TableDataItem key={i}>{formatConverter(item.tlKm)}</TableDataItem>
                            ))
                        }
                    </tr>

                    {/* //! Litre/Km */}
                    <tr>
                        <TableDataItem isNumber={true}><PiEqualsBold className="equal-icon"/></TableDataItem>
                        <TableDataItem isTitle={true}>Litre/Km</TableDataItem>
                        {
                            costCalculateDataList.map((item,i) => {
                                return {
                                    litreKm: item?.litreKm,
                                }
                            }).map((item, i) => (
                                <TableDataItem key={i}>{formatConverter(item?.litreKm)}</TableDataItem>
                            ))
                        }
                    </tr>
    
                </tbody>
            </table>
        </Container>
  )
}

export default CostCalculateResponse1